import { useCharacterCompassStore } from '../store/useCharacterCompassStore';
import Button from '@/components/Button';
import { AnimatePresence } from 'framer-motion';

export const CharacterCompassFinished = ({
  onClickShowCompassTrackerButton,
  showCalendarAndRelatedContent,
}: {
  onClickShowCompassTrackerButton: () => void;
  showCalendarAndRelatedContent?: boolean;
}) => {
  const { Trait, SubTrait } = useCharacterCompassStore();

  const trait = Trait?.attributes;

  return (
    <AnimatePresence>
      <div className="mx-auto my-sh-30 flex max-w-[600px] flex-col items-center justify-center gap-y-8">
        <>
          <h1 className="text-center font-cadiz text-sh-28-32">{trait?.trait || ''}</h1>
          <p className="text-center text-sh-14-18">{trait?.description}</p>
          <img
            src={trait?.overallMoodIcon?.data?.attributes?.url}
            className="h-24 w-24 md:h-[250px] md:w-[250px]"
            alt={trait?.trait}
          />
          <h2 className="max-w-[400px] text-center font-cadiz text-sh-22-28 font-bold">
            {SubTrait?.microExercisePrompt?.title}
          </h2>

          <div
            className="w-full rounded-[16px] border border-[#A1C3EC] p-5 text-center [&>p]:text-sh-18-24"
            dangerouslySetInnerHTML={{
              __html: SubTrait?.microExercisePrompt?.content || '',
            }}
          />

          {!showCalendarAndRelatedContent && (
            <>
              <Button
                onClick={() => {
                  onClickShowCompassTrackerButton();
                }}>
                Check your compass tracker
              </Button>
            </>
          )}
        </>
      </div>
    </AnimatePresence>
  );
};
